<template>
  <el-card class="card-main">
    <div class="left">
      <div v-for="(item, index) in projectDeviceList" :key="index" class="parent" @click="changeProject(index)">
        <div class="header">
          <div class="title">
            <span>{{ item.projectName || '--' }}</span>
            <i class="el-icon-arrow-up" v-if="activeName === index"></i>
            <i class="el-icon-arrow-down" v-else></i>
          </div>
          <div class="inline">
            <p><span class="dot"></span><span class="tit">离线</span> <span class="cou">{{ item.offDeviceNum || 0
            }}</span>
            </p>
            <p><span class="dot1"></span><span class="tit">在线</span> <span class="cou">{{ item.onDeviceNum || 0
            }}</span>
            </p>
          </div>
        </div>
        <div class="child_div" v-show="activeName === index">
          <div v-for="(item1, index1) in item.devices" :class="{ 'active': active === index1 }" :key="index1"
            class="child" @click.stop="choose(item1, index1)">
            <div class="header">
              <span>{{ item1.deviceName }}</span>
              <span class="tag" :class="{ offline: item1.deviceStatus !== '1' }">{{ item1.deviceStatus === '1' ? '在线'
                : item1.deviceStatus === '2' ?
                  '离线' : '- -' }}</span>
            </div>
            <div class="content">设备串号：{{ item1.deviceNumber }}</div>
          </div>
        </div>
      </div>
    </div>
    <div id="map"></div>
    <div class="drawer" :class="drawer ? 'drawerShow' : 'drawerHide'">
      <template v-if="drawerData">
        <div class="info">
          <p class="text">设备名称<span>{{ drawerData.deviceName || '--' }}</span></p>
          <p class="text">设备串号<span>{{ drawerData.deviceNumber || '--' }}</span></p>
          <p class="text">设备状态
            <span class="highlight" :class="drawerData.deviceStatus !== '1' ? 'gray' : ''">
              {{ drawerData.deviceStatus === '1' ? '在线' : drawerData.deviceStatus === '2' ? '离线' : '- -' }}
            </span>
          </p>
        </div>
        <div class="line paramList">
          <div class="paramItem">
            <p class="ttl">当前状态</p>
            <p>{{ drawerData.switchStatus === '1' ? '开启' : drawerData.switchStatus === '0' ? '关闭' : '--' }}</p>
          </div>
          <div class="paramItem">
            <p class="ttl">控制模式</p>
            <div class="model">
              <span class="local" :class="{ active: lcEnable === '0' }">本地模式</span>
              <span class="remote" :class="{ active: lcEnable === '1' }">远程模式</span>
            </div>

            <el-tooltip v-if="lcEnable === '0'" class="item" effect="dark" content="本地模式下无法启动定时计划和远程控制" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="tabs" @click="showTips">
          <div class="tabs-button">
            <!-- :disabled="lcEnable === '0' || deviceStatus !== '1'" -->
            <button @click="activeTab = 'tab1'" class="tab-button1"
              :class="{ 'tabactive': activeTab === 'tab1' }">定时计划</button>
            <button @click="switchTab('tab2')" class="tab-button2"
              :class="{ 'tabactive': activeTab === 'tab2' }">远程控制</button>
          </div>
          <!-- 内容区域 -->
          <div class="tab-content">
            <div v-show="activeTab === 'tab1'">
              <el-button @click="mistforestPlanInsert" class="tab-btn">新增</el-button>
              <div class="card-container" v-if="timeplanList && timeplanList.length > 0">
                <template v-for="(item, it) in timeplanList">
                  <mistforestPlanList :is-active="currentIndex === it" :disabled="disabled" :deviceStatus="deviceStatus"
                    :key="item.planId" @click.native="changePlan(it)" :list="item" @delete="handlerdelete"
                    @update="handlerupdate">
                  </mistforestPlanList>
                </template>
              </div>
              <div class="card-container" v-else>
                <template>
                  <mistforestPlanList></mistforestPlanList>
                </template>
              </div>
            </div>
            <div v-show="activeTab === 'tab2'">
              <p class="tab2-p">开启时长
                <el-select :class="showCustomInput ? 'tab2-selectd' : 'tab2-select'" v-model="selectedValue" clearable
                  placeholder="选择开启时长" @change="handleChange"
                  :disabled="lcEnable === '0' || deviceStatus !== '1' || switchStatus === '1'">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-input v-if="showCustomInput" v-model="customInput" placeholder="请输入开启时长"
                  :disabled="lcEnable === '0' || deviceStatus !== '1'" style="width: 120px;"></el-input>
                <span v-if="showCustomInput">分钟</span>
              </p>
              <p class="tab2-p">远程开关
                <el-switch active-value="1" inactive-value="0" :disabled="lcEnable === '0' || deviceStatus !== '1'"
                  v-model="drawerData.switchStatus" @change="swicthControl($event)" active-color="#7973ef"
                  inactive-color="#999">
                </el-switch>
              </p>
            </div>
          </div>
        </div>
      </template>
    </div>
    <mistforestPlanAdd :showDialog.sync="showDialog" :id="id" :data="params" @planManage="handlerplanManage">
    </mistforestPlanAdd>
  </el-card>
</template>

<script>
import { drawPolygon } from '@/utils/formatData'
import mistforestPlanAdd from './mistforestPlanAdd.vue'
import mistforestPlanList from './mistforestPlanList.vue'
export default {
  name: 'DetailMap',
  components: {
    mistforestPlanAdd,
    mistforestPlanList
  },
  data() {
    return {
      drawer: false,
      map: null,
      ploygons: [],
      markers: [],
      onlineImgOpen: require('@/assets/icon/mistForest/open.svg'),
      onlineImgClose: require('@/assets/icon/mistForest/close.svg'),
      offImg: require('@/assets/icon/mistForest/offline.svg'),
      deviceList: [],
      drawerData: null,
      projectDeviceList: [],
      projectId: '',
      active: -1,
      projectLocation: [],
      activeName: 0,
      lcEnable: null,
      activeTab: 'tab1',
      id: '',
      params: {},
      showDialog: false,
      selectedValue: '',
      customInput: '',
      options: [
        {
          value: '15',
          label: '15分钟'
        },
        {
          value: '30',
          label: '30分钟'
        },
        {
          value: '60',
          label: '60分钟'
        },
        {
          value: 'custom',
          label: '自定义'
        }
      ],
      timeplanList: [],
      currentIndex: -1,
      disabled: false,
      deviceStatus: null,
      switchStatus: null
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  destroyed() {
    if (this.markers) {
      this.markers.forEach((item) => {
        item.off('click', this.drawerOpen)
      })
    }
    if (this.ploygons) {
      this.ploygons.forEach(item => {
        item.off('click', this.drawerClose)
      })
    }
    if (this.map) {
      this.map.off('click', this.drawerClose)
      this.map.clearMap()
    }
  },
  computed: {
    showCustomInput() {
      return this.selectedValue === 'custom';
    }
  },
  methods: {
    // 提示
    switchTab(tabName) {
      this.activeTab = tabName;
      if (this.lcEnable === '0') {
        this.$message({ message: '本地模式下无法启动定时计划和远程控制', type: 'warning' })
      }
    },
    showTips() {
      // if(this.drawerData.deviceStatus === '2') {
      //   this.$message({ message: '设备离线，无法操作', type:'warning' })
      // }
    },
    //处理删除
    handlerdelete() {
      this.getPlanList(this.drawerData.deviceNumber)
    },
    // 处理编辑
    handlerupdate(val) {
      console.log(val, 'val编辑id');
      this.id = val.planId
      this.showDialog = true;
      this.params = JSON.parse(JSON.stringify(val));
    },
    // 查询所有的雾森计划
    getPlanList(deviceNumber) {
      this.$axios.get(this.$apis.iot.selectJgSprayPlanByPage, {
        page: 1,
        pageSize: 100,
        projectId: this.projectId,
        deviceNumber: deviceNumber
      }).then((res) => {
        this.timeplanList = res.list || [];
      })
    },
    // 处理计划操作
    handlerplanManage() {
      this.getPlanList(this.drawerData.deviceNumber);
      this.showDialog = false;
    },
    handleChange(val) {
      if (val !== 'custom') {
        this.customInput = ''; // 清除自定义输入值当选择其他选项时
      }
    },
    //新增 计划
    mistforestPlanInsert() {
      this.showDialog = true;
      this.id = null;
      console.log(this.drawerData, 'drawerData');
      this.params = JSON.parse(JSON.stringify(this.drawerData));
      console.log(this.params, '23456');
    },
    // 左侧项目列表
    getData() {
      this.$axios.get(this.$apis.iot.selectProjectJgSprayByList).then(res => {
        this.projectDeviceList = res || []
        if (this.projectDeviceList.length > 0) {
          this.projectId = this.projectDeviceList[0].projectId
          this.getPloygon()
        } else {
          this.$nextTick(() => {
            this.initMap(116.4017, 39.9)
          })
        }
      })
    },
    getPloygon() {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then((res) => {
        console.log(res, 'dianwei');

        if (res) {
          this.projectLocation = res.locationList || []
          const lng = Number(res.longitude)
          const lat = Number(res.latitude)
          this.$nextTick(() => {
            this.initMap(lng, lat)
          })
        } else {
          this.$message.error('未获取到项目信息')
        }
      })
    },
    // 初始化地图
    initMap(lng, lat) {
      const center = [lng, lat]
      const map = new AMap.Map('map', {
        center: center,
        zoom: 11
      })
      this.map = map
      this.ploygons = drawPolygon(this.map, this.projectLocation || [], null, this.drawerClose)
      this.getDeviceList()

      // 点击地图关闭抽屉
      this.map.on('click', this.drawerClose)
    },

    // 获取设备信息
    getDeviceList() {
      this.$axios.get(this.$apis.iot.selectJgSprayInfoByPage, {
        projectId: this.projectId
      }).then((res) => {
        if (this.projectDeviceList.length > 0) {
          this.projectDeviceList[this.activeName].devices = res.jgSprayInfo.list
        }
        this.drawMarker(res.jgSprayInfo.list)
        this.$forceUpdate()
      })
    },

    choose(row, index) {
      this.active = index
      if (this.map) {
        const e = {
          target: {}
        }
        if (row.longitude && row.latitude) {
          e.target = this.markers.find((item) => {
            return item.detail.deviceNumber === row.deviceNumber
          })
          this.map.setCenter([Number(row.longitude), Number(row.latitude)])
        } else {
          // this.iconTab()
          e.target = {
            detail: row
          }
        }
        this.drawerOpen(e)
      }
    },
    // 切换项目
    changeProject(index) {
      this.active = -1
      const id = this.projectDeviceList[index].projectId
      if (this.projectId !== id) {
        this.projectId = id
        this.activeName = index
        this.getPloygon()
        this.drawerClose()
      } else {
        this.activeName = -1
        this.projectId = ''
      }
    },
    // 切换计划
    changePlan(index) {
      this.currentIndex = index
    },
    // 获取图片
    getIcon(deviceStatus, switchStatus, isCurrent) {
      if (!isCurrent) {
        return (deviceStatus === '1' ? (switchStatus === '1' ? this.onlineImgOpen : this.onlineImgClose) : this.offImg)
      }
    },

    // 地图打点
    drawMarker(list) {
      this.markers = []
      if (list && list.length) {
        // 循坏将设备marker添加到地图
        list.forEach((item) => {
          if (item.longitude && item.latitude) {
            const icon = this.getIcon(item.deviceStatus, item.switchStatus, false)
            const marker = new AMap.Marker({
              icon: new AMap.Icon({
                // 图标的取图地址
                image: icon
              }),
              offset: new AMap.Pixel(-18, -48),
              position: new AMap.LngLat(Number(item.longitude), Number(item.latitude)),
              extData: { ...item, type: 'icon' },
              label: {
                direction: 'top',
                content: "<div class='labelContent'>" + item.deviceName + "</div>",
                offset: new AMap.Pixel(-5, -10),
              }
            })
            marker.detail = item
            marker.on('click', this.drawerOpen)
            this.map && this.map.add(marker)
            this.markers.push(marker)
          }
        })
      }
    },

    // 抽屉打开
    async drawerOpen(e) {
      const info = e.target.detail
      if (this.drawerData === null || (this.drawerData && this.drawerData.deviceNumber !== info.deviceNumber)) {
        if (this.drawerData && this.drawerData.deviceNumber !== info.deviceNumber) {
          this.drawerClose()
        }
        this.drawerData = await this.getDeviceDetail(info.deviceNumber)
        this.deviceStatus = this.drawerData.deviceStatus
        this.lcEnable = this.drawerData.lcEnable
        this.switchStatus = this.drawerData.switchStatus
        if (this.lcEnable === '0') {
          this.disabled = true
        }
        this.getPlanList(this.drawerData.deviceNumber)
      }
      this.drawer = true
      // 点击切换大图标

      const iconClick = this.getIcon(e.target.detail.deviceStatus, e.target.detail.switchStatus, true)
      e.target.setOffset(new AMap.Pixel(-22, -64))
      e.target.setIcon(iconClick)
    },
    // 抽屉关闭
    drawerClose() {
      if (this.drawer) {
        this.drawer = false
        // 清空抽屉
        this.iconTab()
        this.drawerData = null
      }
    },
    getDeviceDetail(deviceNumber) {
      return this.$axios.get(this.$apis.iot.selectJgSprayInfoByDeviceNumber, {
        deviceNumber: deviceNumber
      })
    },
    swicthControl(event) {
      const command = this.drawerData.switchStatus
      if (this.selectedValue === 'custom') {
        this.drawerData.keepLength = this.customInput
      } else {
        this.drawerData.keepLength = this.selectedValue
      }
      // 判断开关状态(关的时候无需keeplength参数)
      if (!command) {
        // 开启时必须设置开启时长
        if (!this.drawerData.keepLength) {
          this.$message.warning('请先设置开启时长');
          this.drawerData.switchStatus = event === '1' ? '0' : '1';
          return;
        }
        this.switchUpdate(command)
      } else {
        this.switchUpdate(command)
      }
    },

    // 远程开关
    switchUpdate(command) {
      this.$axios.post(this.$apis.iot.updateJgSprayInfoRecord, {
        deviceNumber: this.drawerData.deviceNumber,
        switchStatus: this.drawerData.switchStatus,
        execLength: this.drawerData.keepLength
      }).then(() => {
        if (this.map && this.drawerData && this.drawerData.deviceNumber) {
          this.drawerData.switchStatus = command
          this.iconTab()
        }
        this.$message.success((command === '1' ? '开启' : '关闭') + '成功')
        this.switchStatus = this.drawerData.switchStatus
        console.log(this.switchStatus, 'sssss111')
        // 成功后清空选择值
        this.selectedValue = ''
        this.customInput = ''
      }).catch(() => {
        this.drawerData.switchStatus = command === '1' ? '0' : '1';
        this.$message.error((command === '1' ? '开启' : '关闭') + '失败')
      }).finally(() => {
        if (this.valveStatusUpdateLoading) {
          this.valveStatusUpdateLoading.close()
        }
      })
    },
    // 替换图标
    iconTab() {
      if (this.map && this.drawerData) {
        const deviceNumber = this.drawerData.deviceNumber || ''
        const index = this.markers.findIndex((item) => item.detail.deviceNumber === deviceNumber)
        const icon = this.getIcon(this.drawerData.deviceStatus, this.drawerData.switchStatus, false)
        const marker = this.markers[index]
        if (this.drawerData.longitude && this.drawerData.latitude) {
          marker.setOffset(new AMap.Pixel(-18, -48))
          marker.setIcon(icon)
        }
      }
    },

    onDetail(id, state) {
      // 设备详情
      this.$router.push({
        name: 'mowLawnDetail',
        params: { projectId: this.projectId, deviceNumber: id },
        query: {
          state
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/color.scss';

.el-card {
  height: 100%;
}

::v-deep .el-card__body {
  position: relative;
  height: 100%;
  display: flex;
}

.left {
  width: 342px;
  height: 100%;
  background: #F6F7FB;
  border-radius: 2px;
  margin-right: 16px;
  padding: 6px;
  overflow: auto;

  .parent {
    width: 290px;
    margin-bottom: 10px;

    .header {
      height: 60px;
      background: #FFFFFF;
      padding: 8px 10px 8px;
      color: #000;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      cursor: pointer;

      .title {
        display: flex;
        justify-content: space-between;
      }

      .inline {
        display: flex;

        p {
          margin-right: 30px;
        }
      }

      .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #9B9B9B;
        border-radius: 2px;
        margin-right: 4px;
      }

      .dot1 {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #7ED321;
        border-radius: 2px;
        margin-right: 4px;
      }
    }

    .tit {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
    }

    .cou {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
    }
  }

  .child_div {
    width: 278px;
    margin-top: 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;

    .child {
      width: 100%;
      height: 88px;
      background: #FFFFFF;
      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;

      &.active {
        border: 2px solid #1ad1b0;

        .header {
          background: rgba(26, 209, 176, .1) !important;
        }
      }

      .header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 44px;
        background: #F6F7FB;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        text-align: left;
        padding: 11px 16px;
      }

      .tag {
        width: 44px;
        height: 20px;
        background: #1AD1B0;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.offline {
          background: #999999;
        }
      }

      .content {
        padding: 11px 16px;
      }
    }
  }
}

.container {
  width: 100%;
  height: 100%;
  background: #FFFFFF;

  .online {
    width: 270px;
    height: 200px;
    position: absolute;
    left: 40px;
    top: 90px;
    background-color: #fff;
    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    z-index: 10;

    &>div {
      width: 100%;
      height: 100%;
    }
  }

  #map {
    width: calc(100% - 200px);
    height: 100%;
  }

  ::v-deep .amap-marker-label {
    border: 1px solid #fff;
  }
}

.drawer {
  position: absolute;
  right: -420px;
  top: 100px;
  z-index: 20;
  width: 380px;
  height: calc(100% - 145px);
  padding: 16px;
  background: #FFFFFF;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  border-left: 4px solid $color-default;
  transition: all 0.4s;
  overflow: auto;

  .title {
    font-size: 16px;
    color: $color-font-dark;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .info {
    padding-bottom: 20px;

    .text {
      font-size: 14px;
      color: $color-font-dark;
      font-weight: 500;
      line-height: 30px;
      position: relative;

      span {
        margin-left: 10px;
        color: $color-font-default;
      }

      .highlight {
        display: inline-block;
        position: absolute;
        text-align: center;
        width: 44px;
        top: -50%;
        margin-top: 20px;
        background: $color-default;
        border-radius: 2px;
        color: #fff;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
      }

      .gray {
        background: #B7B7B7;
      }
    }
  }

  .tabs {
    width: 340px;

    .tabs-button {
      width: 100%;
      display: flex;

      .tab-button1 {
        font-size: 14px;
        width: 50%;
        height: 24px;
        line-height: 24px;
        background-color: #fff;
        border: 1px solid #D9D9D9;
        border-radius: 4px 0 0 4px;
        box-shadow: inset 0 1px 0 0 #F5F5F5;
      }

      .tab-button2 {
        font-size: 14px;
        width: 50%;
        height: 24px;
        line-height: 24px;
        background-color: #fff;
        border: 1px solid #D9D9D9;
        border-radius: 0 4px 4px 0;
        box-shadow: inset 0 1px 0 0 #F5F5F5;
      }

      .tabactive {
        color: #007A64;
        background: #CCF7EF;
        border: 1px solid #00D5AF;
      }
    }

    .tab-content {
      width: 100%;
      margin-top: 10px;
      font-size: 12px;

      .tab-btn {
        width: 88px;
        background: #1AD1B0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        font-style: normal;
      }

      .card-container {
        width: 100%;
        margin-top: 10px;
      }

      .tab2-p {
        display: flex;
        align-items: center;
        gap: 10px;
        height: 32px;

        .tab2-select {
          width: 150px;
        }

        .tab2-selectd {
          width: 90px;
        }
      }


    }
  }

  .line {
    border-top: 1px solid #F1F1F1;
    padding-top: 20px;
  }

  .paramList {
    margin-bottom: 20px;

    .paramItem {
      display: flex;
      margin-bottom: 10px;

      p {
        font-size: 14px;
        line-height: 24px;
        color: #333;

        &.ttl {
          width: 66px;
          color: #000;

          &.ttl-long {
            width: 94px;
          }
        }

        .large {
          font-family: 'DINAlternateBold';
          font-size: 24px;
          color: #52C41A;
          vertical-align: baseline;
          padding-right: 5px;
        }

        &.c-block {
          width: auto;
          height: 20px;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 18px;
          border-radius: 2px;
          padding: 0px 8px;
        }

        &.c-block.yellow {
          background: #FFC117;
        }

        &.c-block.green {
          background: #45B6AC;
        }

        &.c-block.blue {
          background: #1EA2FF;
        }

        &.c-red {
          color: #FF603B;
        }

        &.c-yellow {
          color: #FFC117;
        }

        &.c-green {
          color: #13C2C2;
        }

        &.c-danger {
          color: #FE3A2F;
        }
      }

      .model {
        display: flex;
        align-items: center;
        font-size: 13px;

        .local {
          width: 80px;
          height: 24px;
          line-height: 24px;
          border-radius: 8px 0px 0px 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #C3C3C3;
          text-align: right;
          font-style: normal;
          padding: 0 12px 0 0;
        }

        .remote {
          width: 80px;
          height: 24px;
          line-height: 24px;
          margin-left: 0;
          border-radius: 0px 8px 8px 0px;
          background: #F5F5F5;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #C3C3C3;
          text-align: left;
          font-style: normal;
          padding: 0 0 0 12px;
        }

        .active {
          background: #469BFF;
          color: #fff;
        }
      }

      .item {
        margin: 4px;
      }

      .el-progress {
        width: 160px;
        height: 8px;
        margin: 8px 5px 0 0;

        ::v-deep {

          .el-progress-bar__outer,
          .el-progress-bar__inner {
            border-radius: 1px;
          }
        }
      }

      .el-link {
        font-size: 12px;
        height: 20px;
        margin-left: 10px;
        border-bottom: 1px solid #1AD1B0;
      }
    }

    .paramItems {
      margin-bottom: 10px;

      p {
        font-size: 14px;
        line-height: 24px;
        color: #333;

        &.ttl {
          width: 66px;
          color: #000;

          &.ttl-long {
            width: 94px;
          }
        }
      }

      .timeDis {
        margin-left: 16px
      }
    }

    .paramError {
      display: flex;

      img {
        margin-right: 4px;
      }
    }
  }
}

.drawerShow {
  transform: translateX(-460px)
}

.drawerHide {
  transform: translateX(0px)
}

.btnControl {
  background-color: #2C8EFF;
  border-color: #2C8EFF;
}

::v-deep .amap-info-close {
  display: none;
}

::v-deep .amap-marker-label {
  border: 0 !important;

  .marker-label-content {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }

  &::after {
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-5px);
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    /* 三角形左边透明 */
    border-right: 5px solid transparent;
    /* 三角形右边透明 */
    border-top: 5px solid #FFFFFF;
    /* 三角形顶部为黑色，可以根据需要修改颜色 */
  }
}

::v-deep .labelContent {
  font-size: 14px;
  font-weight: bold;
  background: #ffffff;
}
</style>
